import {React, useState, useEffect} from 'react'
import DatePicker from 'react-datepicker';
import { format, parse } from 'date-fns';
import { faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { APIConstants, CommonAPIConstants, RemittanceConstants } from '../utilities/Constants';
import { faTriangleExclamation, faStar, faCircleInfo, faArrowsRotate, faAnglesDown, faAnglesUp, faXmark, faArrowRight, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import RemittanceClaimCounts from './RemittanceClaimCounts';

import Draggable from 'react-draggable'

const Remittance = () => {


    const [startDate, setStartDate] = useState(''); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(false);
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [unprocessedFile, setunprocessedFile] = useState([]);
    const [processedFile, setprocessedFile] = useState([]);
    const [remittanceData, setRemittanceData] = useState([]);
    const [selectedRemitFile, setselectedRemitFile] = useState('');
    const [fileExtension, setFileExtension] = useState('');
    const [base64File, setBase64File] = useState('');
    const [showDataModal, setShowDataModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState('');
    const [hasFetched, setHasFetched] = useState(false);

    const [rowState, setRowState] = useState({});
    const [isHidden, setIsHidden] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
     const [activeRow, setActiveRow] = useState(null);


    const userData = useSelector((state) => state.user.user);
    console.log('userData:', userData);
  


    
  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;


  const sAuthToken = useSelector((state) => state.user.user.sAuthToken);



    useEffect(() => {
        document.title ='Upload Remittance'

        // Set the default last 7 days' date range
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() -1);

        setStartDate(sevenDaysAgo);
        setEndDate(today);
    
    }, []);




    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);
           
            console.log("Selected start date:", formattedDate);
            setEndDate(date);
            setIsStartOpen(false)
        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);
            console.log("Selected End date:", formattedDate);
            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };






    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };








    const handleTodayClick = (dateType) => {
        const today = new Date();
      
        if (dateType === "start" && startDate) {
          setStartDate(today);
          setEndDate(today);
          setIsStartOpen(false);
        }
      
        if (dateType === "end" && endDate) {
          setEndDate(today);
          setIsEndOpen(false);
        }
      };
      
    
    
     const CalendarContainer = ({ children }) => (
        <div style={{zIndex:'99px', backgroundColor:'white', border:'1px solid lightgray'}}>
          {children}
          <div style={{  justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd' , marginLeft:'65px' }}>
           <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
              Today
            </button>
            
          </div>
        </div>
      );
    
    
      const CalendarStartContainer = ({ children }) => (
        <div style={{zIndex:'99px', backgroundColor:'white', border:'1px solid lightgray'}}>
          {children}
          <div style={{  justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd' , marginLeft:'65px' }}>
              <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
              Today
            </button>
            
          </div>
        </div>
      );
    






      const handleGetUnprocessFileDetails = async () => {


        var jsonOBJ = {
            PracticeID: userPracticeID,
            isProcessed: 0,
            FromDate: startDate,
            ToDate: endDate
        }

       var sInputJSON = JSON.stringify(jsonOBJ);
    
    
        const url = `${APIConstants.BASE_URL_BILLING}${RemittanceConstants.GetRemittanceFileDetails}?sInputJSON=${sInputJSON}`;
    
        console.log("URL: ", url);
    
        fetch(url, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sAuthToken}`
          }
        })
    
          .then((response) => {
            if (response.status != 200) { console.log("response.status", response.status); }
            else return response.json();
          })
          .then(data => {
    
    
    
            const parsedData = JSON.parse(data)
           
            setunprocessedFile(parsedData)
    
            console.log("Unproceessedfile Response of" + RemittanceConstants.GetRemittanceFileDetails, parsedData);
    
    
    
    
          })
          .catch((error) => {
            console.error('Error fetching:', error);
          });
      }









      const handleGetProcessedFileDetails = async () => {


        var jsonOBJ = {
            PracticeID: userPracticeID,
            isProcessed: 2,
            FromDate: startDate,
            ToDate: endDate
        }

       var sInputJSON = JSON.stringify(jsonOBJ);
    
    
        const url = `${APIConstants.BASE_URL_BILLING}${RemittanceConstants.GetRemittanceFileDetails}?sInputJSON=${sInputJSON}`;
    
        console.log("URL: ", url);
    
        fetch(url, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sAuthToken}`
          }
        })
    
          .then((response) => {
            if (response.status != 200) { console.log("response.status", response.status); }
            else return response.json();
          })
          .then(data => {
    
    
    
            const parsedData = JSON.parse(data)
           
            setprocessedFile(parsedData)
    
            console.log("Proceessedfile Response of" + RemittanceConstants.GetRemittanceFileDetails, parsedData);
    
    
    
    
          })
          .catch((error) => {
            console.error('Error fetching:', error);
          });
      }





      const handleGetRecentFileDetails = async () => {


        var jsonOBJ = {
            PracticeID: userPracticeID,
            isProcessed: 1,
            FromDate: startDate,
            ToDate: endDate
        }

       var sInputJSON = JSON.stringify(jsonOBJ);
    
    
        const url = `${APIConstants.BASE_URL_BILLING}${RemittanceConstants.GetRemittanceFileDetails}?sInputJSON=${sInputJSON}`;
    
        console.log("URL: ", url);
    
        fetch(url, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sAuthToken}`
          }
        })
    
          .then((response) => {
            if (response.status != 200) { console.log("response.status", response.status); }
            else return response.json();
          })
          .then(data => {
    
    
    
            const parsedData = JSON.parse(data)
           
            setRemittanceData(parsedData)
    
            console.log("Response of" + RemittanceConstants.GetRemittanceFileDetails, parsedData);
    
    
    
    
          })
          .catch((error) => {
            console.error('Error fetching:', error);
          });
      }





      const handleAllFileDetails =  () => {


        handleGetUnprocessFileDetails()
        handleGetProcessedFileDetails()
        handleGetRecentFileDetails()

      }



      
  useEffect(() => {
    if (!hasFetched && startDate && endDate) {

      handleAllFileDetails();
      setHasFetched(true);
    }
  }, [startDate, endDate, hasFetched]);




      const handleGetRemitFilePath= async (item) => {


        setselectedRemitFile(item.FilePath)
       
        var jsonOBJ = {
            PracticeID: userPracticeID,
            isProcessed: 1,
            FileName: item.FileName
        }

       var sInputJSON = JSON.stringify({objFileDetails: jsonOBJ});
    
    
       var InputJSON = JSON.stringify(sInputJSON);


   
        console.log("Input of " + RemittanceConstants.GetRemitFileWebPath, sInputJSON);
      
        fetch(APIConstants.BASE_URL_BILLING + RemittanceConstants.GetRemitFileWebPath, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sAuthToken}`
          },
          body: InputJSON,
        })
    
    
       
          .then((response) => {
            if (response.status != 200) { console.log("response.status", response.status); }
            else return response.json();
          })
          .then(data => {
    
    
    
           const parsedData=JSON.parse(data)
           const file= parsedData.WebPath
           window.open(file, '_blank');
 
           
           console.log("Response of" + RemittanceConstants.GetRemitFileWebPath, parsedData);
    
    
    
    
          })
          .catch((error) => {
            console.error('Error fetching:', error);
          });
      }




      const handleUnprocessRemitFilePath= async (item) => {


        setselectedRemitFile(item.FilePath)
       
        var jsonOBJ = {
            PracticeID: userPracticeID,
            isProcessed: 0,
            FileName: item.FileName
        }

       var sInputJSON = JSON.stringify({objFileDetails: jsonOBJ});
    
    
       var InputJSON = JSON.stringify(sInputJSON);


   
        console.log("Input of " + RemittanceConstants.GetRemitFileWebPath, sInputJSON);
      
        fetch(APIConstants.BASE_URL_BILLING + RemittanceConstants.GetRemitFileWebPath, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sAuthToken}`
          },
          body: InputJSON,
        })
    
    
       
          .then((response) => {
            if (response.status != 200) { console.log("response.status", response.status); }
            else return response.json();
          })
          .then(data => {
    
    
    
           const parsedData=JSON.parse(data)
           const file= parsedData.WebPath
           window.open(file, '_blank');
 
           
           console.log("Response of" + RemittanceConstants.GetRemitFileWebPath, parsedData);
    
    
    
    
          })
          .catch((error) => {
            console.error('Error fetching:', error);
          });
      }



    





      const handleProcessRemitFile = async (e) => {
        setIsUploading(true)

        console.log("unprocessedFile", unprocessedFile[0]);
    
     
    
        const inpuJson = {
                     
            sRemitFolder: unprocessedFile[0].FilePath,
            sFileName:'',
            sCleringHourse:'',
            sExt:unprocessedFile[0].FileType,
            sPracticeID: userPracticeID,
            iUserID: userData.userID,
            iRoleID: 7
          
        }
        
    
        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of Process File  " + RemittanceConstants.ProcessRemitanceFile, inputData);
    
        try {
          const response = await fetch(APIConstants.BASE_URL_REMIT + RemittanceConstants.ProcessRemitanceFile, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sAuthToken}`
            },
            body: inputData
          })
    
    
    
          if (response.status !== 200) {
            console.log("Error: Received response status", response.status);
            setIsUploading(false); 
            return;
          }
    
     
          setIsUploading(true)
    
          setTimeout(() => {
            setIsUploading(false); 
            handleAllFileDetails();
          }, 1000);
 
        
    
        } catch (error) {
          console.error('An error occurred:', error);
          setIsUploading(false)
        }
      };





      

      const handleFileChange = (e) => {
        const files = e.target.files; // Get all selected files
        if (files.length > 0) {
          Array.from(files).forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
              const base64 = reader.result.split(',')[1]; // Get Base64 content
              handleUploadingFile(base64, file.name); // Pass Base64 and file name to the function
            };
            reader.readAsDataURL(file); // Read file as Base64
          });
        }
      };
      


      


      useEffect(() => {
        console.log('Base64 String:------', base64File, selectedRemitFile?.File);
        // handleUploadingFile()

      },[base64File, selectedRemitFile])







      const handleUploadingFile = async (base64File, selectedRemitFile) => {
         
        console.log("selectedRemitFile", selectedRemitFile, base64File);

        const inpuJson = {
          PracticeID: userPracticeID,
          FileName: selectedRemitFile,
          FileContent: base64File,
          UserID: userData.userID,
          DefaultTimeZoneOffSet: userData.DefaultTimeZoneOffSet,
        };

        
        const myInput = JSON.stringify({ objFileDetails: inpuJson });
        const inputData = JSON.stringify(myInput)
        console.log("Input of " + RemittanceConstants.UploadingFile, inputData);
      
        try {
          const response = await fetch(
            APIConstants.BASE_URL_BILLING + RemittanceConstants.UploadingFile,
            {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`,
              },
              body: inputData,
            }
          );
      
          console.log("HTTP Status:", response.status);
      
          
          if (!response.ok) {
            console.error(`Error: ${response.status} - ${response.statusText}`);
            return;
          }
      
          const data = await response.text();
          console.log("Response of " + RemittanceConstants.UploadingFile, data);
                  handleGetUnprocessFileDetails()
            //const data = JSON.parse(response);
          
        
        } catch (error) {
          console.error("Error fetching:", error);
        }
      };
      

  







      const handleGetMultipleClaimDetails=  (item) => {

        setShowDataModal(true)
       
        setSelectedItem(item); 
       
      }










      const handleDelete =  (item) => {


    
          const objClaim = {
    
            PracticeID  : userPracticeID,
            RemitDetailsID: item.RemitDetailsID + "",
            FileName: item.FileName,
          
    
           
    
          }
    
  
    
        console.log("objClaim", objClaim);
      
        var sInputJSON = JSON.stringify({objFileDetails:objClaim});
        console.log("inputRow of" + RemittanceConstants.DeleteRemitFile, sInputJSON);
      
     
    
    
        
        const url = `${APIConstants.BASE_URL_BILLING}${RemittanceConstants.DeleteRemitFile}?sInputJSON=${sInputJSON}`;
    
        console.log("URL: ", url);
    
        fetch(url, {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sAuthToken}`
          }
        })
         
        .then(data => {
    
    
          if(data.status === 200)
          {
            handleGetUnprocessFileDetails()
          }
  
          console.log("Response of" + RemittanceConstants.DeleteRemitFile, data);
  
  
  
  
        })
        .catch((error) => {
          console.error('Error fetching:', error);
        });
    }
    






    const handleReProcessRemitFile= async (item) => {


      setRowState((prevState) => ({
        ...prevState,
        [item.RemitDetailsID]: { isLoading: true, isHidden: false }
      }));
        
    
     
    
     
      var jsonOBJ = {
          sPracticeID: userPracticeID,
          iUserID: userData.userID,
          FromDate: startDate,
          FileName: item.FileName,
          iRoleID: userData.roleID

      }


     var sInputJSON = JSON.stringify({objFileDetails : jsonOBJ});
  
  
     var InputJSON = JSON.stringify(sInputJSON);


 
      console.log("Input of " + RemittanceConstants.ReProcessRemitFile, sInputJSON);
    
      fetch(APIConstants.BASE_URL_REMIT + RemittanceConstants.ReProcessRemitFile, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`
        },
        body: InputJSON,
      })
  
  
     
        .then((response) => {
          if (response.status != 200) { console.log("response.status", response.status); }
          else return response.json();
        })
        .then(data => {
  
  
          setRowState((prevState) => ({
            ...prevState,
            [item.RemitDetailsID]: { isLoading: false, isHidden: true },
          }));
      
  

         
         console.log("Response of" + RemittanceConstants.ReProcessRemitFile, data);
  
  
  
  
        })
        .catch((error) => {
          console.error('Error fetching:', error);

          setRowState((prevState) => ({
            ...prevState,
            [item.RemitDetailsID]: { isLoading: false, isHidden: false },
          }));
        });
    }







    const handleRowClick = (index) => {
      setActiveRow(index);
    };
  




      
  const formatDOSDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };



  const handleCloseModals = () => {
    // Close all modals
    
    setShowDataModal(false)
    
  };






    return (
        <>

            <div className='remittance-container'>

                <label className='file-heading'>Upload Remittance Files</label>


                <div className='upload-container'>
                    <div className='border-container'>


                        <div className="mb-3" style={{ marginLeft: '500px' }}>

                            <input className="form-control form-control-sm"  type="file" id="formFileMultiple" multiple  style={{width:'300px'}}
                             
                             onChange={handleFileChange}
                            />

                        </div>

                      
                         
                        
                 
                        <button className='btn-style3' style={{marginLeft:'550px'}} onClick={handleProcessRemitFile}>Proess Files</button>
                        
                        {isUploading && (
                           <FontAwesomeIcon style={{ marginLeft: '10px'}} className='rotating-icon'  icon={faSpinner} />
                        )}

                    </div>

                </div>





             




                <div className='remittance-table mt-5'>
                    <table className="table table-hover table-striped table-bordered border border-white responsive mt-1 " style={{width:'100%'}}>

                        <thead>

                            <tr className='align-top' >

                                <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#

                                    
                                </th>


                                <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7', width: '380px' }}>Unprocessed Files Name
                               
                                 <br/>
                                <input type='text'
                                      placeholder='Search'
                                      style={{width:'120px', borderRadius:'5px'}}

                                    />
                                </th>


                              

                                <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '180px' }}>Type

                                </th>

                                <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '280px'}}>Date Added

                                </th>

                                <th className='col col-th-style text-white ' style={{ backgroundColor: '#0173b7', width: '180px'}}>	Added By


                                </th>


                                <th className='col col-th-style text-white ' style={{ backgroundColor: '#0173b7', width: '280px'}}>Action


                                </th>
                               




                            </tr>


                        </thead>

                        <tbody>
                               

                        {unprocessedFile.map((item, index) => (

                          <tr key={index}>
                              <td>{index+1}</td>
                              <td>{item.FileName}</td>
                              
                              <td>{item.FileType}</td>
                              <td>{formatDOSDate(item.AddedDate)}</td>
                              <td>{item.UserFname}</td>
                              <td>
                                <button className='btn-style3' onClick={()=>handleDelete(item)}>Delete</button>
                                <button className='btn-style3' onClick={()=>handleUnprocessRemitFilePath(item)}>View</button>
                              </td>

                          </tr>
                          ))}



                        </tbody>


                    </table>

                   



                </div>


               
               

               



                <div className='remittance-table mt-5'>
                    <table className="table table-hover table-striped table-bordered border border-white responsive mt-1 " style={{width:'100%'}}>

                        <thead>

                            <tr className='align-top' >

                                <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#</th>


                                <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7', width: '380px' }}>Processing Files
                                     <br/>
                                <input type='text'
                                      placeholder='Search'
                                      style={{width:'120px', borderRadius:'5px'}}

                                    />
                                </th>


                               

                                <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '180px' }}>Type

                                </th>

                                <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '280px'}}>Date Added

                                </th>

                                <th className='col col-th-style text-white ' style={{ backgroundColor: '#0173b7', width: '180px'}}>	Added By


                                </th>


                                <th className='col col-th-style text-white ' style={{ backgroundColor: '#0173b7', width: '280px'}}>Action


                                </th>
                               




                            </tr>


                        </thead>

                            <tbody>


                            {processedFile.map((item, index) => (

                            <tr key={index}>
                                <td>{index+1}</td>
                                <td>{item.FileName}</td>
                                
                                <td>{item.FileType}</td>
                                <td>{formatDOSDate(item.AddedDate)}</td>
                                <td>{item.UserFname}</td>
                                <td>
                                  
                                </td>

                            </tr>
                            ))}


                           
                        </tbody>


                    </table>


                </div>




              






                <div className='d-flex mt-5'>
                <div className="datepicker-container" style={{ marginLeft: '500px', zIndex: 10 }}>
                                    <label>From:</label>
                                    <DatePicker
                                        selected={startDate ? new Date(startDate) : null}
                                        onChange={handleStartDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                      
                                        className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                                        placeholderText="MM/dd/yyyy"

                                        calendarContainer={CalendarStartContainer}
                                        open={isStartOpen}
                                        onFocus={() => setIsStartOpen(true)}
                                        onInputClick={() => setIsStartOpen(true)}
                                        onClickOutside={() => setIsStartOpen(false)}
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}  style={{height:'25px'}}>
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option key={k} value={new Date().getFullYear() - k}>
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}  style={{height:'25px'}}>
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>

                                <div className="datepicker-container" style={{ marginLeft: '20px', zIndex: 10 }}>
                                    <label>To:</label>
                                    <DatePicker
                                        selected={endDate ? new Date(endDate) : null}
                                        onChange={handleEndDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                        className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                                        placeholderText="MM/dd/yyyy"
                                        popperPlacement="bottom-start"
                                      
                                        calendarContainer={CalendarContainer}
                                        open={isEndOpen}
                                        onFocus={() => setIsEndOpen(true)}
                                        onInputClick={() => setIsEndOpen(true)}
                                        onClickOutside={() => setIsEndOpen(false)}
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}  style={{height:'25px'}}>
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option key={k} value={new Date().getFullYear() - k}>
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}  style={{height:'25px'}}>
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>



                                <div className='searchicon-container' style={{ marginLeft: '10px', marginTop: '1px' , height:'30px' }}>
                                <FontAwesomeIcon style={{ marginLeft: '7px'}} onClick={handleAllFileDetails} icon={faMagnifyingGlass} />
                            </div>

                </div>





                <div className='remittance-table mt-5'>
                    <table className="table table-hover table-striped table-bordered border border-white table-info responsive mt-1 " style={{width:'100%'}}>

                        <thead>

                            <tr className='align-top' >

                                <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#</th>


                                <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7', width: '380px' }}>	Recently Processed Files
                                <br/>
                                    <input type='text'
                                        placeholder='Search'
                                        style={{width:'120px', borderRadius:'5px'}}

                                        />
                                </th>

                                <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '180px' }}>Total Claims 

                                </th>

                                <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '180px' }}>Type

                                </th>

                                <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '280px'}}>Date Added

                                </th>

                                <th className='col col-th-style text-white ' style={{ backgroundColor: '#0173b7', width: '180px'}}>	Added By


                                </th>


                                <th className='col col-th-style text-white ' style={{ backgroundColor: '#0173b7', width: '280px'}}>Action


                                </th>
                               




                            </tr>


                        </thead>

                        <tbody>

                        {remittanceData.map((item, index) => (

                                <tr className={`${activeRow === index ? 'table-warning' : ''} ${'table-success'}`}

                                key={index}
                                onClick={() => handleRowClick(index)}>
                                    <td>{index+1}</td>
                                    <td>{item.FileName}</td>
                                    <td>
                                        <button className='btn-style3' style={{width:'30px'}} onClick={()=>handleGetMultipleClaimDetails(item)}>
                                          
                                          {item.ClaimsCount}</button>

                                          {
                                !rowState[item.RemitDetailsID]?.isHidden && (

                                        <FontAwesomeIcon
                                            style={{ marginLeft: '40px' }}
                                            onClick={()=>handleReProcessRemitFile(item)}
                                            icon={faArrowsRotate}
                                            className={rowState[item.RemitDetailsID]?.isLoading ? 'rotating-icon' : ''}
                                        />

                                )}
                                    </td>
                                    <td>{item.FileType}</td>
                                    <td>{formatDOSDate(item.AddedDate)}</td>
                                    <td>{item.UserFname}</td>
                                    <td>
                                       <button className='btn-style3' onClick={()=>handleGetRemitFilePath(item)}>View</button>
                                    </td>

                                </tr>
                                ))}
                          
                                
                          </tbody>
                     
                          {showDataModal && (
                            <>

                            

                              <Draggable>
                               
                                <div className='dialog-remitbox' >
                                <FontAwesomeIcon style={{width:'18px', height:'18px', borderRadius:'999px', border:'1px solid black',
                                  float:'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor:'red', color:'white'}} onClick={handleCloseModals} icon={faXmark} />
                                
                                  <RemittanceClaimCounts selectedItem={selectedItem} />

                                

                                </div>
                              </Draggable>
                            </>

                              )}

                       



                    </table>



                   

                   
                </div>


                

  

            </div>






        </>
    )
}

export default Remittance